import styled from "styled-components";

export const StyledTable = styled.div`
  & th {
    background-color: ${({ theme }) => theme.sportNonLive.HeaderBackground};
    color: white; // TODO: we will add this one to theme object later
    font-size: 14px;
    border: 1px solid ${({ theme }) => theme.sportNonLive.Border};
    padding: 8px;
  }

  & td {
    border: 1px solid ${({ theme }) => theme.sportNonLive.Border};
    padding: 8px;
    font-size: 16px;
    white-space: pre-wrap;
    text-align: center;
    vertical-align: middle;
  }

  & th.league {
    background-color: ${({ theme }) =>
      theme.sportNonLive.TitleLeagueBackground};
  }

  & tr.odd-row {
    background-color: ${({ theme }) => theme.sportNonLive.TableBackground};
  }

  & tr.even-row {
    background-color: ${({ theme }) => theme.sportNonLive.TableHardBackground};
  }

  & th:first-child,
  td:first-child {
    width: 80px;
  }

  & th:nth-child(2),td:nth-child(2) {
    width: 200px;
  }
`;
